import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const UserIcon = () => {
  const { currentUser } = useAuth();

  return (
    <Link
      to={currentUser ? "/profile" : "/login"}
      className="nav-user-link header-action"
      aria-label={currentUser ? "حساب کاربری" : "ورود"}
    >
      <div className={`icon user-icon ${currentUser ? "logged-in" : ""}`}>
        {currentUser && <div className="login-indicator"></div>}
      </div>
    </Link>
  );
};

export default UserIcon;
